import styled from 'styled-components'


export const StyledHeaderWrapper = styled.div`
	position: fixed;
	top: var(--admin-bar-height, 0px);
	left: 0;
	width: 100%;
	z-index: 17;
	background-color: white;
	box-shadow: 0px 0px 7px 0px rgba(0, 0, 0, 0.15);
	border-bottom: 1px solid #CDCDCD;
	& > svg {
		align-self: center;
	}
	.container{
		& .link-text{
			display: none;
		}
		@media (max-width: 768px) {
			padding: 0;
			width: 542px;
			max-width: 100%;
		}
	}
	.container .logo_and_menu{
		width: 1180px;
		margin: 0 auto;
		position: relative;
		display: flex;
		padding: 0px 30px;
		align-items: center;
		justify-content: center;
		height: 50px;
		-moz-transition: all ease 0.2s;
		-o-transition: all ease 0.2s;
		-webkit-transition: all ease 0.2s;
		transition: all ease 0.2s;
		// TABLET MENU
		@media (max-width: 1200px) {
			width: 734px;
			& .menu {
				position: fixed;
				backdrop-filter: blur(6px);
				top: calc(50px + var(--admin-bar-height, 0px));
				left: calc(50% - 367px);
				-moz-transition: top ease 0.35s;
				-o-transition: top ease 0.35s;
				-webkit-transition: top ease 0.35s;
				transition: top ease 0.35s;
				width: 734px;
				height: 100%;
				overflow: auto;
				&>div {
					width: 270px;
					height: calc(100vh - 50px - var(--admin-bar-height, 0px));
					background-color: white;
					flex-direction: column;
					justify-content: space-between;
					border: 1px solid #CDCDCD;
					overflow: hidden;
					box-shadow: 0px 0px 7px 0px rgba(0, 0, 0, 0.15);
				}
			}
			.hideMenu{
				top: -100%;
			}
		}
		@media (max-width: 767px) {
			padding: 0;
			width: 542px;
			max-width: 100%;
			height: 80px;
			& .menu {
				width: 542px;
				top: calc(80px + var(--admin-bar-height, 0px));
				left: calc(50% - 271px);
				//height: calc(100vh - 80px);
				&>div {
					width: 320px;
					max-width: 100%;
				}
				& .logout_wrapper{
					margin-bottom: 29px;
				}
			}
			.hideMenu{
				top: -100%;
			}
		}
		@media (max-width: 543px) {
			& .menu {
				width: 100%;
				left: 0;
			}
		}
		@media (max-height: 610px) {
			height: 38px;
			& .menu {
				top: calc(38px + var(--admin-bar-height, 0px));
				&>div {
					width: 270px;
					height: calc(100vh - 37px - var(--admin-bar-height, 0px));
				}
				& .logout_wrapper{
					margin-bottom: 0px;
				}
			}
			.hideMenu{
				top: -100%;
			}
			& .logout_wrapper{
				height: 36px;
			}
		}
	}
	// LOGO
	.container .logo_and_menu .logo{
		position: absolute;
		top: calc(50% - 20px);
		left: -10px;
		@media (max-width: 1200px) {
			left: 77px;
			top: calc(50% - 15px);
		}
		@media (max-width: 768px) {
			left: 133px;
			top: calc(50% - 20px);
		}
		@media (max-width: 543px) {
			left: 103px;
			display: ${props => props.searchVisible ? 'none' : 'block'};
		}
		@media (max-height: 610px) {
			& svg{
				width: 103px;
			}
		}
	}

	// SEARCH TABLET (PHONE)
	.container .logo_and_menu .search input{
		background-color: white;
		font-family: Montserrat;
		width: 300px;
		height: 30px;
		font-size: 14px;
		font-weight: 400;
		border-radius: 100px;
		padding-left: 15px;
		padding-right: 15px;
		color: #434343;
		border: 1px solid #CDCDCD;
		box-shadow: none;
		@media (max-width: 768px) {
			width: 100px;
			max-width: 100%;
			padding: 0;
			border: none;
		}
	}

	
	.container .logo_and_menu .search div>svg{
		margin-right: 4px;
	}

	.container .logo_and_menu .search>div:first-child svg{
		@media (max-width: 768px) {
			display: none;
		}
	}

	.container .logo_and_menu .search .search_icon{
		display: none;
	}

	.container .logo_and_menu {

		& .search{
			@media (max-width: 768px) {
				position: relative;
				width: 50px;
				height: 50px;
				max-width: 100%;
				display: flex;
				border-radius: 100px;
				transition: 0.2s;
				z-index: 500;
				@media (max-width: 543px) {
					justify-content: flex-end;
				}
				& div:first-child input {
					width: 0;
				}
				&.search_opened {
					width: 450px;
					& div:first-child {
						position: relative;
						width: 400px;
						height: 50px;
						display: flex;
						justify-content: center;
						align-items: center;
						margin-left: 40px;
						@media (max-width: 543px) {
							width: 83%;
						}
					}

					& div:first-child input {
						position: absolute;
						top: 0;
						width: 100%;
						height: 100%;
						border: 1px solid #CDCDCD;
						outline: none;
						font-size: 24px;
						font-weight: 400;
						padding-left: 40px;
						background-color: #FAFAFA;
						@media (max-width: 543px) {
							padding-left: 20px;
						}
					}
				}

				& .search_icon{
					display: block;
					position: absolute;
					top: -15px;
					right: 0px;
					display: flex;
					justify-content: center;
					align-items: center;
					z-index: 300;
					& svg {
						margin-right: 0;
					}
				}
				
			}
			@media (max-height: 610px) {
				&.search_opened {
					& div:first-child input {
						top: 15%;
						height: 70%;
					}
				}
			}
		}
		
	}

	// BURGER MENU ICON
	.container .logo_and_menu .menu_icon{
		width: 50px;
		height: 50px;
		//border: 1px solid lightgreen;
		z-index: 5;
		display: none;
		position: relative;
		@media (max-width: 1200px) {
			display: block;
		}
		@media (max-width: 768px) {
			//border: 1px solid lightgreen;
			width: 80px;
			height: 80px;
		}
	}

	& .menu_icon span,
	.menu_icon::before,
	.menu_icon::after {
		position: absolute;
		left: 15px;
		height: 2px;
		width: 20px;
		transition: all 0.2s ease 0s;
		background-color: #434343;
		@media (max-width: 768px) {
			left: 20px;
			height: 4px;
			width: 40px;
		}
	}
	& .menu_icon::before,
	.menu_icon::after {
		content: "";
		transition-duration: 0.3s, 0.3s;
		transition-delay: 0.3s, 0s;
	}
	& .menu_icon::before {
		top: 18px;
		transition-property: top, transform;
		@media (max-width: 768px) {
			top: 26px;
		}
	}
	& .menu_icon::after {
		bottom: 18px;
		transition-property: bottom, transform;
		@media (max-width: 768px) {
			bottom: 26px;
		}
	}
	& .menu_icon span {
		top: 50%;
		transform: scale(1) translate(0px, -50%);
	}
	& a {
		text-decoration: none;
	}


	// BURGER MENU ANIMATION

	& .menu_icon_opened span{
		background: none;
	}

	& .menu_icon_opened::before {
		top: 23.55px;
		left: 13.4px;
		transform: rotate(-45deg);
		@media (max-width: 768px) {
			top: 37.95px;
			left: 28.4px;
		}
	}

	& .menu_icon_opened::after {
		left: 22.4px;
		top: 23.55px;
		transform: rotate(-135deg);
		@media (max-width: 768px) {
			top: 37.95px;
			left: 37.4px;
		}
	}

	& .menu_icon_opened::before, .menu_icon_opened::after{
		width: 14px;
		transition-delay: 0s, 0.3s;
		@media (max-width: 768px) {
			height: 2px;
		}
	}

	// ACTIVE MENU ICON
	& .menu-item-active{
		box-shadow: inset 0px 0px 4px 1px rgba(0, 0, 0, 0.15);
		&>.item_wrapper>div{
			background-color: rgba(0,0,0,0);
			& .icon_wrapper>svg{
				& path{
					stroke: #B0B0B0;
				}
				& circle{
					stroke: #B0B0B0;
				}
			}
		}
	}
	// MENU IN COMPUTER
	@media (min-width: 1201px){
		& a {
			& .item_wrapper>div{
				transition: all 0.25s ease-out;
			}
		}
		&:hover{
			& .container .logo_and_menu {
				height: 86px;
				transition: all 0.25s ease-out;
				& .logo{
					display: none;
				}
			}
			& a {
				& .item_wrapper>div{
					transition: all 0.25s ease-out;
				}
				&:nth-child(1){
					& .item_wrapper>div{
						min-width: 131px;
						width: auto;
					}
				}
				&:nth-child(2){
					& .item_wrapper>div{
						min-width: 154px;
						width: auto;
					}
				}
				&:nth-child(3){
					& .item_wrapper>div{
						min-width: 133px;
						width: auto;
					}
				}
				&:nth-child(4){
					& .item_wrapper>div{
						min-width: 140px;
						width: auto;
					}
				}
				&:nth-child(5){
					& .item_wrapper>div{
						min-width: 178px;
						width: auto;
					}
				}
				&:nth-child(6){
					& .item_wrapper>div{
						min-width: 138px;
						width: auto;
					}
				}
				&:nth-child(7){
					& .item_wrapper>div{
						min-width: 123px;
						width: auto;
					}
				}
				&:nth-child(8){
					& .item_wrapper>div{
						min-width: 152px;
						width: auto;
					}
				}
			}
			
			& .container .item_wrapper>div {
				display: flex;
				flex-direction: column;
				align-items: center;
				justify-content: flex-start;
				margin: 0;
				width: 154px;
				height: 86px;
				background-color: white;
				&:hover{
					background-color: #F2F2F2;
				}
				& .icon_wrapper{
					width: 50px;
					height: 50px;
				}
				& .link-text{
					display: inline;
					text-align: center;
					& span{
						color: #434343;
						font-size: 12px;
						font-weight: 600;
						border-bottom: none;
					}
					& p{
						color: #B0B0B0;
						font-size: 10px;
						font-weight: 400;
					}
					
				}
			}
			// ACTIVE MENU ICON
			& .menu-item-active{
				&>.item_wrapper>div{
					background-color: #F2F2F2;
				}
			}
		}
	}

	// MENU IN LEPTOP
	@media (max-width: 1200px){
		// TOP MENU LINE
		& .container .logo_and_menu {
			justify-content: space-between;
			padding: 0 17px;
		}
		

		// ACTIVE MENU ICON
		& .menu-item-active{
			box-shadow: none;
			&>.item_wrapper>div{
				background-color: #F2F2F2;
			}
		}

	}

	// MENU IN PHONE
	@media (max-width: 1200px){
		// TOP MENU LINE
		& .container .logo_and_menu {
			padding-left: 13px;
			padding-right: 8px;
		}
	}
	
`

export const StyledMenuList = styled.div`
	display: flex;
	min-height: 50px;
	& .item_wrapper:hover{
		cursor: pointer;
		background-color: #F2F2F2;
		& svg{
			& path{
				stroke: #B0B0B0;
			}
			& circle{
				stroke: #B0B0B0;
			}
		}
	}
	@media (max-width: 1200px) {
		& .logout_wrapper{
			background-color: white;
			border-top: 1px solid #CDCDCD;
			width: 270px;
			height: 59px;
			display: flex;
			//justify-content: center;
			align-items: center;
			&>svg{
				margin-left: 17px;
				margin-right: 5px;
			}
			&>span{
				font-size: 14px;
				font-weight: 500;
				display: block;
			}
		}
	}

	@media (max-width: 768px) {
		& .logout_wrapper{
			width: 320px;
			max-width: 100%;

			&>svg{
				margin-left: 13px;
				margin-right: 10px;
			}

			&>span{
				font-size: 16px;
			}
		}
	}

	@media (max-height: 610px) {
		& .logout_wrapper{

			&>svg{
				margin-right: 10px;
				width: 30px;
			}

			&>span{
				font-size: 14px;
			}
		}
	}
`
